var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",attrs:{"to":_vm.listPath}},[_c('Button',{attrs:{"isBright":"true"}},[_vm._v(_vm._s(_vm.listObject.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }